import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

const namespace = 'manageReports';

const PositionModel = {
  namespace,
  state: initialState,
  effects: makeListEffects({
    namespace,
    fetchRoute: 'report',
    fetchParams: 'ManageReports',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState,
  }),
};

export default PositionModel;
